/* eslint-disable react/prop-types */
import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  pageHeaderRoot: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
      flexDirection: 'row'
    }
  },
  titleRoot: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: 10
    }
  },
  pageHeader: {
    marginBottom: '3rem'
  }
}));

const PageHeader = ({ heading, breadcrumbComponent, children, ...rest }) => {
  const classes = useStyles();

  return (
    <Box className={clsx(classes.pageHeaderRoot, classes.pageHeader)} mb={{ xs: 5, md: 6, lg: 8 }} {...rest}>
      <Typography component="div" variant="h3" className={clsx(classes.titleRoot, 'title')}>
        {heading}
      </Typography>
      <Box ml={{ sm: 'auto' }}>{breadcrumbComponent}</Box>

      {children}
    </Box>
  );
};

export default PageHeader;
